<template>
  <div class="carousel in-block" :class="transitionClass" v-if="isCarousel" :style="transitionStyle">
    <carousel
        :perPage=1
        :navigation-enabled="controls"
		    :pagination-enabled="controls"
        :navigationClickTargetSize=15.4
        :pagination-padding="6"
        :autoplay="advance"
		    :autoplay-timeout = "frameDuration*1000"
		    :duration="frameDuration"
        :loop="true"
        :mouse-drag="false"
        :touch-drag="false"
        v-on:pageChange="pageChange"
        @navigation-click="navigationHandler"
        @pagination-click="navigationHandler"
        aria-label="carousel"
    >
      <slide :class="[transitionClass, {initialSlide: currentSlide === 0 }]"><product-element v-bind="$props" /></slide>
      <slide v-for="(slide,i) in slideBlocks" :key="i" @slideclick="handleSlideClick" :class="transitionClass">
        <product-element :block-data="slide" v-bind="$props" />

      </slide>

    </carousel>
  </div>
</template>

<script>
import blockElementMixin from "@/mixins/blockElementMixin";
import ProductElement from "@/components/block/elements/ProductElement.vue";
import { Carousel, Slide } from 'vue-carousel';
import { mapActions, mapGetters, mapState } from "vuex";
import Lytics from "../../../classes/Lytics";

export default {
  name: "ProductCarouselV2",
  components: {ProductElement, Carousel, Slide},
  mixins:[blockElementMixin],
  data(){
    return {
      currentSlide: 0
    }
  },
  mounted() {
    setTimeout(() => {
      // gotta work on this
      const containers = document.getElementsByClassName('VueCarousel-dot-container');
      containers.forEach( container => {
        const dots = container.getElementsByClassName('VueCarousel-dot');
        dots.forEach((dot, index) => {
          dot['title'] = ``;
          dot['value'] = `Slide ${index+1}`;
          dot.setAttribute('aria-label', `Slide ${index+1}`);
        });
      });
    }, 1000)
  },
  computed:{
    ...mapState(['currentPageNumber']),
    ...mapGetters(['highlightResults']),
    ...mapGetters('search', ['showSearchResults']),
    slideBlocks(){
      return this.blockData?.carouselBlocks;
    },
    isCarousel() {
      return (this.blockData?.carouselBlocks?.length ?? 0) >= 1;
    },
    controls() {
			return this.blockData?.controls !== undefined ? this.blockData?.controls : true
		},
		advance() {
			return this.blockData?.advance  ?? false
		},
		frameDuration() {
			const duration = this.blockData?.fraDur ?? 1;
			return isNaN(duration) ? 1 : duration
		},
		transitionDuration() {
			return this.blockData?.transDur ? `${this.blockData.transDur}s` : `0.3s`;
		},
		transitionClass() {
			switch(this.blockData?.effect?.toLowerCase()) {
				case 'fading':
					   return 'fade-effect';
				case 'appear':
					   return 'appear-effect';
				case 'slide':
					   return 'slide-effect';
				default:
					  return 'slide-effect';
			}
		},
		transitionStyle() {
			return {'--trans-duration': `${this.transitionDuration}`}
		}
  },
  methods:{
    ...mapActions('events', ['triggerEvent']),
    handleSlideClick (dataset) {
      console.log("Slide click info ",dataset.index, dataset.name)
    },
    navigationHandler(i){
      const direction = i > this.currentSlide ? 'right' : 'left';
      const blocks = this.slideBlocks
      Lytics.TriggerCarouselClick({
				carousel_frame: i + 1,
				carousel_id: this.blockId,
				carousel_interaction: direction,
				carousel_url: blocks[i]?.images[0]?.image,
				total_click_include: true,
                page_number: this.page.page_num || this.currentPageNumber,
                is_search: this.searchIsVisible
			})
      this.triggerEvent( {
        event: 'carouselInteraction',
        data: {
          frame: i + 1,
          direction: direction,
          carouselId: this.blockId
        },
      })
		},
    pageChange(i)
    {
      if(i)
        this.currentSlide = i
      else
        this.currentSlide = 0

      const blocks = this.slideBlocks
      this.narration = this.currentSlide == 0 ? this.blockData.products[0]?.contents :blocks[this.currentSlide-1].products[0]?.contents
      const navBtns = document.getElementsByClassName('VueCarousel-navigation-button')
      navBtns.forEach((btn) => {
        btn.ariaLabel = this.narration
      });
      return this.currentSlide
    },
  }
}
</script>

<style lang="scss" >
.ProductCarouselV2 {
  display: initial !important;
  .carousel {
    .VueCarousel {
      position:inherit;

      .VueCarousel-inner {
			   	margin-left: -0.5px;
	    }

      .VueCarousel-navigation {
        position: relative;
        bottom:25px;
        margin:0 auto;

        .VueCarousel-navigation-button {
          cursor: pointer;
          background: none;
          /*	height: 45px;
            width: 45px;*/
          min-height: 17px !important;
          min-width: 17px !important;
          background-size: contain;
          background-position: center;
          border-radius: 50%;
          font-size: 0;
          opacity: .7;
          transition: opacity 200ms, filter 100ms;
          z-index: 1100;
          margin:0 -28px;

          &:hover {
            opacity: 1;
          }
          &.VueCarousel-navigation-prev {
            background-image: url("/images/moveleft-arrow-desktop.png");
            padding: 0 !important;
            //left: 36% !important;
          }
          &.VueCarousel-navigation-next {
            background-image: url("/images/moveright-arrow-desktop.png");
            padding: 0 !important;
            //right: 36% !important;
          }
          &.VueCarousel-navigation--disabled {
            opacity: 0.3 !important;
          }
          &:focus:not(:focus-visible) {
            outline: none;
          }
        }
      }

      .VueCarousel-pagination {
        z-index: 1000;
        margin-top: -3.4em;

        .VueCarousel-dot-container {
          -webkit-backface-visibility: hidden;
          -ms-transform: translateZ(0); /* IE 9 */
          -webkit-transform: translateZ(0); /* Chrome, Safari, Opera */
          opacity: 0.9;
          background: none;
          pointer-events: none;

          &:hover {
            opacity: 1;

            .VueCarousel-dot--active{
              background: rgba(0, 0, 0) !important;
              outline: none !important;
            }
          }

          .VueCarousel-dot {
            min-height: unset;
            min-width: unset;
            transform: scale(-0.7);
            /* height: 7.2px !important;
             width: 7.2px !important;
             margin-left: 1.7px ;
             margin-right: 1.7px;*/
            padding: 0 !important;
            border: 1px solid rgb(0, 0, 0);
            background: rgb(255, 255, 255) !important;

          }
          .VueCarousel-dot:focus {
            outline: none !important;
          }

          .VueCarousel-dot--active{
            background: rgba(0, 0, 0, 0.7) !important;
          }

        }
      }
    }
  }
  .carousel.slide-effect {
		.VueCarousel-inner {
			transition: transform var(--trans-duration) ease !important;
		}
	}
	.carousel.fade-effect {
		.VueCarousel-inner {
			transition: transform 0s !important;
			.VueCarousel-slide.fade-effect {
             opacity: 0;
             transition: opacity var(--trans-duration) ease;
            }
		   .VueCarousel-slide-active.fade-effect,
		   .initialSlide.fade-effect {
            opacity: 1;
            }
		}


	}
	.carousel.appear-effect {
		.VueCarousel-inner {
			transition: transform 0s !important;
			.VueCarousel-slide.fade-effect {
             opacity: 0;
            }
		   .VueCarousel-slide-active.appear-effect,
		   .initialSlide.appear-effect {
            opacity: 1;
            }
		}


	}
}

/*Mobile*/
@media (min-width: 280px ) and (max-width: 819px) {
  .ProductCarouselV2 {
    .carousel {
      .VueCarousel {
        .VueCarousel-navigation {
          .VueCarousel-navigation-button {
            height: 14px !important;
            width: 14px !important;
            margin: 0 -29px !important;
            font-size: 0;
          }
        }

        .VueCarousel-pagination {
          margin-top: -3.45em;
          .VueCarousel-dot-container {
            .VueCarousel-dot {
              transform: scale(-0.4) !important;
              margin: 7px -5px !important;

            }
          }
        }
      }
    }
  }
}


/*Tablet*/
@media (min-width: 820px) and (max-width: 1023px) {
  .ProductCarouselV2 {
    .carousel {
      .VueCarousel {
        .VueCarousel-navigation {
          .VueCarousel-navigation-button {
            height: 24.5px !important;
            width: 24.5px !important;
            margin: 0 -42px !important;
            font-size: 0;
          }
        }

        .VueCarousel-pagination {
          margin-top: -62px !important;

          .VueCarousel-dot-container {
            .VueCarousel-dot {
              transform: scale(-0.5) !important;
              margin: 14px -2px !important;
            }
          }
        }
      }
    }
  }
}
</style>
